module.exports = __webpack_public_path__ + "img/ford-new.62862409.png";